import styled from 'styled-components';
import { Typography } from '@mui/material';

const StyledText = styled(Typography)`
  font-size: 15px;
  padding-right: 50px;
`;

export {
  StyledText,
};
